import React from "react";
// Daily Data Collection Report page

// Default
import { useState, useEffect } from "react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import DatePickerInput from "../../forms/input/DatePickerInput";
import CustomDataTable from "../../components/table/CustomTable";
import DailyDataCollectionBarChart from "../charts/DailyDataCollectionBarChart";

const DailyDataCollectionReport: React.FC = () => {
  const [reportData, setReportData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  useEffect(() => {
    const generateRandomData = () => {
      const data = [];
      for (let i = 1; i <= 10; i++) {
        const expectedReads = Math.floor(Math.random() * 30) + 20;
        const receivedReads = Math.floor(Math.random() * expectedReads);
        data.push({
          meterId: `Meter${i}`,
          expectedReads,
          receivedReads,
          percentageReceived: ((receivedReads / expectedReads) * 100).toFixed(
            2
          ),
        });
      }
      return data;
    };

    setReportData(generateRandomData());
  }, []);

  const COLUMNS = [
    "Meter ID",
    "Expected Reads",
    "Received Reads",
    "Percentage Reads",
  ];

  const rowsContent = reportData?.map((item, index) => (
    <TableRow
      key={index}
      sx={{
        height: "50px",
        background: (index + 1) % 2 ? "#F9FCFE" : "transparent",
      }}
      className="custom_table_tbody"
    >
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.meterId}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.expectedReads}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.receivedReads}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.percentageReceived}
        </Typography>
      </TableCell>
    </TableRow>
  ));

  return (
    <Layout>
      <Card className="meters_title_card">
        <Typography variant="h5">Daily Data Collection Report</Typography>
      </Card>

      <Card sx={{ mt: "20px", maxHeight: "400px" }}>
        <CardHeader
          title={
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="h5">Daily Data Collection</Typography>
              <Stack direction={"row"} gap={"20px"} alignItems={"center"}>
                <DatePickerInput
                  placeholder={"dd/mm/yyyy"}
                  width={"fit-content"}
                />
                <DatePickerInput
                  placeholder={"dd/mm/yyyy"}
                  width={"fit-content"}
                />
                <ContainedButton
                  label={"Apply Filters"}
                  sx={{
                    width: "fit-content",
                    height: "42px",
                    mt: "10px",
                    color: "#ffffff",
                  }}
                />
              </Stack>
            </Stack>
          }
        />
        <Divider />

        <CardContent>
          <DailyDataCollectionBarChart reportData={reportData} />
        </CardContent>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={<Typography variant="h5">Meter Details</Typography>}
        />
        <Divider />

        <CardContent sx={{ overflow: "auto", maxHeight: "600px" }}>
          <CustomDataTable
            columns={COLUMNS}
            pagination={true}
            rowsContent={rowsContent}
            Actions={true}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            page={page}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalCount={reportData?.length}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};

export default DailyDataCollectionReport;
